import Section1 from './section1'
import Section2 from './section2'
import Section3 from './section3'
import Section4 from './section4'
import Section5Parallax from './section5-parallax'
import Footer from './footer'

import { useScrollDepthTracker } from '@/shared/hooks/use-scroll-depth-tracker'
import { postAmplitude } from '@/core/lib'

const SectionContainer = ({ containerRef }: { containerRef: React.RefObject<HTMLDivElement> }) => {
  const handlePrevent = (e: React.SyntheticEvent) => {
    e.preventDefault()
  }

  useScrollDepthTracker({
    containerElement: containerRef,
    scrollContentElement: containerRef,
    onTrigger: (checkpoint) => {
      postAmplitude('scroll_in_glassis_main_page', {
        checkpoint,
      })
    },
  })

  return (
    <div
      ref={containerRef}
      className={`hide-scrollbar absolute h-[100dvh] w-full overflow-y-scroll snap-y snap-mandatory`}
      onContextMenu={handlePrevent}
      onTouchStart={handlePrevent}
      onSelect={handlePrevent}
    >
      <div className="h-[100dvh] snap-start">
        <Section1 />
      </div>
      <div className="h-[100dvh] snap-start">
        <Section2 />
      </div>
      <div className="h-[100dvh] snap-start">
        <Section3 containerRef={containerRef} />
      </div>
      <div className="h-[100dvh] snap-start">
        <Section4 containerRef={containerRef} />
      </div>
      <div className="snap-start">
        <div className="h-[2140px] relative z-10">
          <Section5Parallax containerRef={containerRef} />
        </div>
        <div className="relative z-20">
          <Footer />
        </div>
      </div>
    </div>
  )
}

export default SectionContainer
